import { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { timerManager } from "../../utils/timerManager";

const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  background: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  background-color: transparent;
  color: #314158;
  line-height: 100%;

  @media (max-width: 1200px) {
    font-size: 18px;
    padding: 8px 16px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 6px 12px;
  }

  ${({ header }) =>
    header &&
    css`
      padding: 0;
      font-family: "Open Sans", sans-serif;

      svg {
        width: 16px;
        height: 16px;
      }
    `}
`;

const IconButton = styled.div`
  margin-right: 5px;
  cursor: pointer;
  font-size: 20px;
  color: #555;

  &:hover {
    color: #000;
  }

  @media (max-width: 1200px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ServiceTimer = ({ header = false }) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    timerManager.start();
    const unsubscribe = timerManager.subscribe(setElapsedTime);

    return () => unsubscribe();
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <TimerContainer header={header}>
      <IconButton onClick={() => setVisible(!visible)}>
        {visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
      </IconButton>
      <span>{visible ? formatTime(elapsedTime) : "----"}</span>
    </TimerContainer>
  );
};

export default ServiceTimer;
